var _a, _b;
import getConfig from 'next/config';
import { stringify } from '@src/utils/qs';
const pixelHost = ((_a = getConfig()) === null || _a === void 0 ? void 0 : _a.publicRuntimeConfig.pixelHost) || process.env.PIXEL_HOST || '';
const pixelNabooHost = ((_b = getConfig()) === null || _b === void 0 ? void 0 : _b.publicRuntimeConfig.pixelNabooHost) ||
    process.env.PIXEL_NABOO_HOST ||
    '';
export const sendGet = ({ path, query, data, host = pixelNabooHost, }) => {
    const url = `${host}${path}`;
    const queryString = stringify(Object.assign(Object.assign({}, (query || {})), data), { addQueryPrefix: false });
    const fetchPromise = fetch(url + `?${queryString}`, {
        mode: 'no-cors',
    });
    return Promise.resolve(fetchPromise);
};
export const sendGetPixel = ({ path, data, host = pixelHost, }) => {
    const url = `${host}${path}`;
    const query = stringify(data, { addQueryPrefix: true });
    const fetchPromise = fetch(url + query, {
        mode: 'no-cors',
    });
    return Promise.resolve(fetchPromise);
};
